import {
  faChevronLeft,
  faChevronUp,
  faChevronDown,
  faChevronRight,
  IconDefinition,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './Footer.css';

import { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../shared/components/button/Button';
import { AuthContext } from '../../shared/context/auth-context';
import { SupportSection } from './SupportSection';

type FooterProps = {
  onNextPage: (values?: any) => void;
  onPrevPage: () => void;
  iProgress: number;
  goals: any[];
};

export function Footer({ onNextPage, onPrevPage, iProgress, goals }: FooterProps) {
  const auth = useContext(AuthContext);
  const { t } = useTranslation();
  const [lastPage, setLastPage] = useState(false);
  const [scrollControlIcon, setScrollControlIcon] = useState<IconDefinition | string>(
    faChevronDown
  );

  const navigateNextPage = () => {
    setScrollControlIcon(faChevronDown);
    onNextPage();
    setScrollControlIcon('down');
  };

  const navigatePrevPage = () => {
    setScrollControlIcon(faChevronDown);
    onPrevPage();
    setScrollControlIcon('down');
  };

  const scrollToBottom = () => {
    const containerHeight =
      document.getElementsByClassName('question_container')[0].clientHeight - 200;
    if (scrollControlIcon === 'down') {
      window.scroll({
        top: containerHeight,
        behavior: 'smooth',
      });
      setScrollControlIcon('up');
    } else {
      window.scroll({
        top: 0,
        behavior: 'smooth',
      });
      setScrollControlIcon('down');
    }
  };

  useEffect(() => {
    if (iProgress) {
      if (iProgress === 13 && auth?.access === '2' && goals?.length > 0) {
        setLastPage(true);
      } else if (goals?.length > 0 && iProgress === 15 && auth.access !== '10') {
        setLastPage(true);
      } else if (iProgress === 16) {
        setLastPage(true);
      } else {
        setLastPage(false);
      }
    }
  }, [iProgress]);

  return (
    <footer className="main_footer" aria-label={t('landmark.footer.label')}>
      <div id="scroll_fade_bottom">
        <button type="button" id="down_icon" onClick={scrollToBottom}>
          <span className="visuallyHidden">
            {t('FTR001')}
            {scrollControlIcon === 'up' ? t('FTR003') : t('FTR002')}
          </span>
          <FontAwesomeIcon
            icon={scrollControlIcon === 'up' ? faChevronUp : faChevronDown}
            className="icon"
          />
        </button>
      </div>
      <div id="progress_footer_container">
        <div id="progress_footer" className="progress_footer">
          {onPrevPage && (
            <Button
              onClick={navigatePrevPage}
              icon={{
                faIconDefinition: faChevronLeft,
                size: '3x',
              }}
              iconPosition="center"
              isDisabled={iProgress === 0}
              id="back"
              type="button"
              ariaLabel={t('A136')}
            />
          )}
          <SupportSection />
          {onNextPage && (
            <Button
              onClick={navigateNextPage}
              icon={
                !lastPage
                  ? {
                      faIconDefinition: faChevronRight,
                      size: '3x',
                    }
                  : null
              }
              iconPosition="center"
              id="next"
              type="button"
              className={lastPage ? 'last_page' : iProgress ? `i${iProgress}` : 'no_progress'}
              ariaLabel={!lastPage ? t('A133') : null}
            >
              {lastPage && (
                <span id="generate_report">
                  {t('A116')}
                  <br />
                  {t('A117')}
                </span>
              )}
            </Button>
          )}
        </div>
      </div>
    </footer>
  );
}
